import React, { useEffect, useState } from "react";
import { FaFilter, FaPhoneAlt, FaUser } from "react-icons/fa";
import { getWalletTrns } from "../../api/endpoints";
import PageHeader from "../../components/PageHeader";

const WalletTransaction = () => {
  const [transactions, setTransactions] = useState([]);
  const [search, setSearch] = useState("");
  const [type, setType] = useState("");
  const [page, setPage] = useState(1);
  const limit = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [loading, setLoading] = useState(false);

  const walletList = async () => {
    try {
      setLoading(true);
      const params = {
        page,
        limit,
      };

      if (search.trim()) {
        params.search = search.trim();
      }

      if (type) {
        params.type = type;
      }

      const res = await getWalletTrns(params);
      console.log("API Response:", res);

      setTransactions(res.data.transactions || []);
      setTotalPages(res.data.totalPages || 1);
    } catch (error) {
      console.log("Error fetching transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    walletList();
  }, [page, search, type]);

  // ✅ Helper function to get user name
  const getUserName = (item) => {
    // First check if userName is directly available
    if (item.userName) {
      return item.userName;
    }
    // Check if userId is an object with fullName
    if (item.userId && typeof item.userId === 'object' && item.userId.fullName) {
      return item.userId.fullName;
    }
    return "N/A";
  };

  // ✅ Helper function to get user mobile
  const getUserMobile = (item) => {
    // First check if userMobile is directly available
    if (item.userMobile) {
      return item.userMobile;
    }
    // Check if userId is an object with mobile
    if (item.userId && typeof item.userId === 'object' && item.userId.mobile) {
      return item.userId.mobile;
    }
    return "N/A";
  };

  // ✅ Helper function to get user referral code
  const getUserReferral = (item) => {
    // Check if userId is an object with referralCode
    if (item.userId && typeof item.userId === 'object' && item.userId.referralCode) {
      return item.userId.referralCode;
    }
    return "-";
  };

  // ✅ Helper function to get user status
  const getUserStatus = (item) => {
    if (item.userStatus) {
      return item.userStatus;
    }
    if (item.userId && typeof item.userId === 'object' && item.userId.status) {
      return item.userId.status;
    }
    return "N/A";
  };

  return (
    <div className="lead-page">
      <PageHeader
        title="Wallet Transactions"
      />

      <div className="card card-light">
        <div className="card-header d-flex justify-content-between">
          <h5 className="mb-0">All Transactions</h5>
          <div className="d-flex gap-2">
            {showFilter && (
              <>
                <input
                  className="form-control"
                  placeholder="Search by User, Game, Remark"
                  value={search}
                  onChange={(e) => {
                    setPage(1);
                    setSearch(e.target.value);
                  }}
                />

                <select
                  className="form-select"
                  value={type}
                  onChange={(e) => {
                    setPage(1);
                    setType(e.target.value);
                  }}
                >
                  <option value="">All Types</option>
                  <option value="BET">Bet</option>
                  <option value="WIN">Win</option>
                  <option value="DEPOSIT">Deposit</option>
                  <option value="WITHDRAWAL">Withdrawal</option>
                  <option value="BONUS">Bonus</option>
                </select>
              </>
            )}

            <button
              className="btn btn-dark"
              onClick={() => setShowFilter(!showFilter)}
            >
              <FaFilter />
              Filter
            </button>
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <table className="table align-middle">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>User</th>
                  <th>Mobile</th>
                  <th>Referral</th>
                  <th>Game</th>
                  <th>Type</th>
                  <th>Amount</th>
                  <th>Before</th>
                  <th>After</th>
                  <th>Remark</th>
                  <th>Date</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="11" className="text-center">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : transactions.length > 0 ? (
                  transactions.map((item, index) => (
                    <tr key={item._id}>
                      <td>{index + 1}</td>

                      {/* ✅ User Name */}
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <FaUser size={12} />
                          {getUserName(item)}
                        </div>
                      </td>

                      {/* ✅ User Mobile */}
                      <td>
                        <FaPhoneAlt size={12} /> {getUserMobile(item)}
                      </td>

                      {/* ✅ User Referral */}
                      <td>
                        <span className="badge bg-info">
                          {getUserReferral(item)}
                        </span>
                      </td>

                      <td>{item.game || "-"}</td>

                      <td>
                        <span
                          className={`badge ${
                            item.type === "WIN" || item.type === "win"
                              ? "bg-success"
                              : item.type === "BET" || item.type === "bet"
                              ? "bg-danger"
                              : "bg-secondary"
                          }`}
                        >
                          {item.type || "N/A"}
                        </span>
                      </td>

                      <td>₹ {item.amount || 0}</td>
                      <td>₹ {item.balanceBefore || 0}</td>
                      <td>₹ {item.balanceAfter || 0}</td>
                      <td>{item.remark || "-"}</td>

                      <td>
                        {item.createdAt
                          ? new Date(item.createdAt).toLocaleDateString()
                          : "N/A"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center">
                      No Transactions Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-center gap-2 mt-3">
              <button
                className="btn btn-sm btn-secondary"
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
              >
                Previous
              </button>

              <span className="mt-1">
                Page {page} of {totalPages}
              </span>

              <button
                className="btn btn-sm btn-secondary"
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WalletTransaction;